import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';
import {
  ConfigureEncryptionRequest,
  TestConnectionResult,
} from './encryption-types';

// Backend wire shape for /encryption/test-connection.
// Matches platform-api schemas.encryption_config.TestConnectionResponse.
interface TestConnectionWireResponse {
  ok: boolean;
  error_code?: string | null;
  error_detail?: string | null;
}

export const testEncryptionConnection = async (
  config: ConfigureEncryptionRequest,
): Promise<TestConnectionResult> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;
  if (!orgId) {
    throw new Error('No organization selected');
  }

  const response = await apiRequest<TestConnectionWireResponse>({
    url: `/organizations/${orgId}/encryption/test-connection`,
    method: 'POST',
    target: 'platform',
    body: config as unknown as Record<string, unknown>,
  });

  if (response?.detail) {
    throw new Error(response.detail || 'Failed to test connection');
  }

  const data = response.data;
  if (!data) {
    return { success: false, message: 'No response from server' };
  }

  if (data.ok) {
    return { success: true, message: 'Connection successful' };
  }

  const summary = data.error_detail || 'Connection failed';
  const code = data.error_code ? ` [${data.error_code}]` : '';
  return { success: false, message: `${summary}${code}` };
};
